import { post } from '@/utils/request'

export type TMechanismIds = number[]

/**
 * 获取效果列表
 */
export interface IEffectList {
  mechanismIds: TMechanismIds
  effect: string
}
export const getEffectList = <T = IEffectList[]>() => {
  return post<T>({ url: '/assistant/material/effectList' })
}

/**
 * 获取机制列表
 */
export interface IMechanism {
  mechanismId: string
  mechanismName: string
}
export const getMechanismList = <T = IMechanism[]>(data: Omit<IEffectList, 'effect'>) => {
  return post<T>({ url: '/assistant/material/mechanismList', data })
}

/**
 * 获取原料建议
 */
export interface IMaterialSuggestion {
  effect: string
  createTime: string
  enterpriseId: number | string | null
  historyId: string
  mechanism: string
  mechanismId: string
  question: string
}
interface IMaterialSuggestionResponse {
  materialName: string[]
  requestId: string
  role: string
}
export const getMaterialSuggestion = <T = IMaterialSuggestionResponse>(data: IMaterialSuggestion) => {
  return post<T>({ url: '/assistant/material/suggest', data })
}
